module.exports = __webpack_public_path__ + "static/media/iconmonstr-shazam-5.01e2636b.png";